module.exports = __webpack_public_path__ + "static/feature-1-ac1955caeeb01eaf69eb35316fe06a8b.png";